import { msalConfig } from '../../../authConfig';

const userHasAccount = (msal) => msal.accounts && msal.accounts.length > 0
const getUserClaims = (msal) => msal.accounts[0].idTokenClaims
const getNewUser = (msal) => userHasAccount(msal) && getUserClaims(msal).newUser
export const isNewUser = (msal) => getNewUser(msal) !== undefined && getNewUser(msal) === true;
export const getUserRole = (msal) => userHasAccount(msal) ? getUserClaims(msal).extension_Role : undefined;
export const hasUserGotAnyRolesFromList = (msal, roles) => roles.some(role => getUserRole(msal) === role);
export const logout = (msal) => msal.instance.logoutRedirect({ postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri })